import { Checkbox, Label, Stack, Text, TooltipHost } from '@fluentui/react';
import { SettingState, useSettingState } from '../../../_contexts/settings/settingsContext';
import { ProjectManagerApproval } from '../../../api/generated/data-contracts';
import { useConfigValuesState } from '../../../hooks/useConfigValue';
import { GridInput } from '../../../types/GridInput';
import { Granularity } from '../../../types/Granularity';
import { useMemo } from 'react';
import { ApproverTableConfig } from './UsersConfig/ApprovalTableConfig';

const useResourceSettingsState: SettingState<ProjectManagerApproval> = key => {
    return useSettingState(
        settings => settings.userFeatures.approval.projectManagerApproval[key],
        (settings, newValue) => {
            settings.userFeatures.approval.projectManagerApproval[key] = newValue;
        },
    );
};

export const ApprovalGridConfig = () => {
    const {
        initialData: {
            configuration: { gridView: _gridView, gridInputType: _gridInputType },
        },
    } = useConfigValuesState();
    const gridView = _gridView as Granularity;
    const gridInputType = _gridInputType as GridInput;

    const [enabled, setEnabled] = useResourceSettingsState('enabled');
    const [ratesEnabled, setRatesEnabled] = useResourceSettingsState('useRates');
    const [enforceRateBeforeApproval, setEnforceRateBeforeApproval] = useResourceSettingsState('enforceRateBeforeApproval');

    const disabledReason = useMemo(() => {
        if (gridInputType === 'percent') {
            return 'Project approval is not supported in percent mode';
        }
        if (gridView === 'period') {
            return 'Project approval is not supported in period mode';
        }
    }, [gridInputType, gridView]);

    return (
        <Stack tokens={{ padding: 10, childrenGap: 10 }}>
            <Text variant="large">Project Approval view</Text>
            <Label>Enable Project Approval view to approve time registered on projects per user and task</Label>
            <Stack horizontal horizontalAlign="start">
                <TooltipHost content={disabledReason}>
                    <Checkbox
                        disabled={Boolean(disabledReason)}
                        checked={enabled}
                        onChange={(e, c) => setEnabled(Boolean(c))}
                        label="Enable Project Approval View"
                    />
                </TooltipHost>
            </Stack>
            {enabled && (
                <Stack tokens={{ childrenGap: 10 }}>
                    <Label>Enable rate card on Project Approval view</Label>
                    <Checkbox checked={ratesEnabled} onChange={(e, c) => setRatesEnabled(Boolean(c))} label="Enable rate card Project Approval view" />
                </Stack>
            )}

            {ratesEnabled && (
                <>
                    <Stack tokens={{ childrenGap: 10 }}>
                        <Checkbox
                            checked={enforceRateBeforeApproval}
                            onChange={(e, c) => setEnforceRateBeforeApproval(Boolean(c))}
                            label="Require rate or activity before approving"
                        />
                    </Stack>
                    <div>
                        <Stack tokens={{ childrenGap: 10 }} style={{ marginTop: 50 }}>
                            <Label>Adjust the table below to change the activity of the Project Approval</Label>
                            <ApproverTableConfig />
                        </Stack>
                    </div>
                </>
            )}
        </Stack>
    );
};
